import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { overviewUrl } from '../../shared/helpers/endPoints';
import { GET_ALL_TRANSACTIONS, GET_RECENT_TRANSACTIONS } from './actionTypes';
import { fetchJSON } from '../../shared/helpers/apiCalls';

import { setAllTransactions, setRecentTransactions } from './action';
import { getStoreLocal } from '../../shared/helpers/utils';
import { authService } from '../../modules/users/services/dependency.injection';

function* callGetAllTransactions({ payload: values }) {
    const access_token = authService.accessToken();
    const modeType = getStoreLocal('modeType');

    try {
        const options = {
            method: 'GET',
            url: overviewUrl(modeType),
            params: { ...values },
            headers: {
                Authorization: `Bearer ${access_token}`
            }
        };

        const response = yield call(fetchJSON, options);

        yield put(setAllTransactions(response.data));
    } catch (error) {}
}

function* callGetRecentTransactions({ payload: values }) {
    const access_token = authService.accessToken();
    const modeType = getStoreLocal('modeType');

    try {
        const options = {
            method: 'GET',
            url: overviewUrl(modeType),
            params: { ...values },
            headers: {
                Authorization: `Bearer ${access_token}`
            }
        };

        const response = yield call(fetchJSON, options);

        yield put(setRecentTransactions(response.data));
    } catch (error) {}
}
export function* watchCallGetRecentTransactions() {
    yield takeEvery(GET_RECENT_TRANSACTIONS, callGetRecentTransactions);
}

export function* watchCallGetAllTransactions() {
    yield takeEvery(GET_ALL_TRANSACTIONS, callGetAllTransactions);
}

function* OverviewSaga() {
    yield all([fork(watchCallGetAllTransactions), fork(watchCallGetRecentTransactions)]);
}
export default OverviewSaga;
